export const OTR_STATUS = {
  DRAFT: 'Draft',

  SUBMITTED: 'Request_Submitted',
  L1_APPROVED: 'Request_L1_Approved',
  APPROVED: 'Request_Approved',

  SENT_BACK: 'Sent_Back',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',

  EXPENSES_SUBMITTED: 'Expenses_Submitted',
  EXPENSES_L1_APPROVED: 'Expenses_L1_Approved',
  EXPENSES_APPROVED: 'Expenses_Approved',
  TRAVEL_PROCESSED: 'Travel_Processed',
};

export const BUDGET_TYPE = {
  LUMPSUM: 'Lumpsum',
  PER_DAY: 'Per day',
  AT_ACTUALS: 'At actuals',
};

export const TRAVEL_PURPOSE = {
  CLIENT_MEETING: 'Client Meeting',
  VENDOR_SUPPLIER_MEETING: 'Vendor/Supplier Meeting',
  SERVICE_CALL: 'Service Call',
  PROJECT_VISIT: 'Project Visit',
  OTHER: 'Other',
};

// Purposes for which a Customer must be captured on the travel request.
// i18n keys (outstation.purposeOptions.*) for the purpose / mode display text.
export const PURPOSE_I18N_KEYS = {
  'Client Meeting': 'clientMeeting',
  'Vendor/Supplier Meeting': 'vendorSupplierMeeting',
  'Service Call': 'serviceCall',
  'Project Visit': 'projectVisit',
  'Other': 'other',
};
export const MODE_I18N_KEYS = { 1: 'bus', 2: 'train', 3: 'cab', 4: 'auto', 5: 'flight',6:'car' };

export const PURPOSE_REQUIRES_CUSTOMER = [
  TRAVEL_PURPOSE.CLIENT_MEETING,
  TRAVEL_PURPOSE.VENDOR_SUPPLIER_MEETING,
  TRAVEL_PURPOSE.SERVICE_CALL,
];

export const CITY_TIERS = {
  TIER_1: 'Tier 1',
  TIER_2: 'Tier 2',
  TIER_3: 'Tier 3',
};

export const APPROVAL_FLOW = {
  MANAGER: 'Manager',
  MANAGER_THEN_FINANCE: 'Manager_Then_Finance',
  FINANCE: 'Finance',
  FINANCE_THEN_MANAGER: 'Finance_Then_Manager',
};

export const MODE_OF_TRAVEL = {
  BUS: 1,
  TRAIN: 2,
  CAB: 3,
  AUTO: 4,
  FLIGHT: 5,
  CAR:6,
};

export const MODE_OF_TRAVEL_LABELS = {
  1: 'Bus',
  2: 'Train',
  3: 'Cab',
  4: 'Auto',
  5: 'Flight',
  6:'Car',
};

/**
 * The API stores only modeOfTravelId. Translate it back to the display name.
 * Prefer a name sent by the backend, then the id lookup, else a dash.
 */
export const getModeOfTravelName = (request = {}) =>
  request?.modeOfTravelName ||
  MODE_OF_TRAVEL_LABELS[Number(request?.modeOfTravelId)] ||
  '—';